import "./header.css";
import { useIsLaptop } from "../constants";
import headshot from "../../assets/headshot4.png";
import Contact from "../contact/Contact";

const Header = () => {
  const isLaptop = useIsLaptop();

  return (
    <header id="header">
      <div className="headerContent">
        <div
          className="motivation"
          style={{ width: isLaptop ? "fit-content" : "100%" }}
        >
          <h1 className="headerText">ISAAC YU</h1>
          <p>
            Studying Systems Design Engineering at the University of Waterloo.{" "}
            <br></br> A software engineer that likes to build in the realms of
            research, <br></br> games, tech-art and full stack applications.
          </p>
          <Contact />
        </div>
        {isLaptop && <img className="headshot" src={headshot} alt="logo" />}
      </div>
    </header>
  );
};

export default Header;
